import { j as e } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { Stack as l } from "@mui/joy";
import { memo as t } from "react";
import { S as o } from "../../../../../../../index.B-E4PB3F.js";
import r from "../../../../DqDatasetSyncControlledInput/DqDatasetSyncControlledInput.js";
import s from "../../labels/ConfigurationLabel/ConfigurationLabel.js";
import m from "../../labels/CredentialsLabel/CredentialsLabel.js";
const n = t(({
  syncDirection: a
}) => /* @__PURE__ */ e.jsxs(l, { children: [
  /* @__PURE__ */ e.jsx(s, {}),
  /* @__PURE__ */ e.jsx(r, { label: "Bucket name", name: `s3.${a === o.IMPORT ? "sourceConfig" : a === o.EXPORT ? "targetConfig" : void 0}.bucket`, placeholder: 'e.g. "my-bucket-name"' }),
  /* @__PURE__ */ e.jsx(r, { label: "Region code", name: `s3.${a === o.IMPORT ? "sourceConfig" : a === o.EXPORT ? "targetConfig" : void 0}.region`, placeholder: 'e.g. "eu-central-2"' }),
  /* @__PURE__ */ e.jsx(r, { label: "Object name (Key)", name: `s3.${a === o.IMPORT ? "sourceConfig" : a === o.EXPORT ? "targetConfig" : void 0}.objectKey`, placeholder: 'e.g. "my-file.csv"' }),
  a === o.IMPORT ? /* @__PURE__ */ e.jsx(r, { label: "Stored dataset name", name: "datasetName", placeholder: 'e.g. "dataset-name"', required: !1 }) : null,
  /* @__PURE__ */ e.jsx(m, {}),
  /* @__PURE__ */ e.jsx(r, { label: "Access key", name: "s3.credentials.accessKey", placeholder: 'e.g. "5JG8C6HNDPQF7W2X3Y1Z"', type: "masked" }),
  /* @__PURE__ */ e.jsx(r, { label: "Secret key", name: "s3.credentials.secretKey", placeholder: 'e.g. "F57yT3QaX2nD8jHr4KlP9cVs1W6zU0E2sY8hN4bM"', type: "masked" })
] }));
n.displayName = "S3FormControls";
export {
  n as default
};
//# sourceMappingURL=S3FormControls.js.map
